/* global angular */

(function() {
    "use strict";

    var app = angular.module('app', ['ngSanitize', 'ngMessages', 'ui.bootstrap', 'ngFileUpload', 'jsonFormatter']);
    
}());